import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'

import translationPT from './pt_BR/translation.json'


// the translations
const resources = {
  pt_BR: {
    translation: translationPT
  }
}

dayjs.locale('pt-br')

i18n.use(initReactI18next).init({
  resources,
  lng: navigator.language,
  fallbackLng: 'pt_BR',
  interpolation: {
    escapeValue: false,
    format: function(value, format, lng) {
      if(value instanceof Date) return value ? dayjs(value).format(format): "";
      return value;
    }
  }
})
export default i18n